"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconCircle = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 45,
        width: 45,
        borderRadius: '50%',
        background: theme.palette.grey[100],
        minHeight: 45,
        minWidth: 45,
        ["& .".concat(_mui.svgIconClasses.root)]: {
            fontSize: '3rem'
        }
    };
});
const IconCircle = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: children
    });
};
exports.IconCircle = IconCircle;
